import { Button, Dropdown, Flex, MenuProps, Typography } from 'antd';
import { FC } from 'react';
import { DashCircle, ExclamationTriangleFill, PencilSquare, ThreeDotsVertical, Trash } from 'react-bootstrap-icons';

import { AppModal } from '@/common/components';
import { useAppModalControls } from '@/common/hooks';

interface Props {
  isItemsDisabled: boolean;
  isDeleteSearchConsoleAccountLoading: boolean;
  handleEditSearchConsoleAccount: () => void;
  handleRevokeTokenOAuth2: () => void;
  handleDeleteSearchConsoleAccount: () => void;
}

export const SearchConsoleAccountsOverviewDropdown: FC<Props> = ({
  isItemsDisabled,
  isDeleteSearchConsoleAccountLoading,
  handleRevokeTokenOAuth2,
  handleEditSearchConsoleAccount,
  handleDeleteSearchConsoleAccount
}) => {
  const [modalControls] = useAppModalControls();

  const items: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <PencilSquare/>,
      label: 'Редагувати',
      disabled: isItemsDisabled,
      onClick: handleEditSearchConsoleAccount,
    },
    {
      key: 'revoke-token',
      icon: <DashCircle/>,
      label: 'Відкликати токен OAuth2',
      disabled: isItemsDisabled,
      onClick: handleRevokeTokenOAuth2,
    },
    {
      key: 'divider',
      type: 'divider',
    },
    {
      key: 'delete',
      disabled: isItemsDisabled,
      danger: true,
      icon: <Trash/>,
      onClick: modalControls.open,
      label: 'Видалити',
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} placement="bottomRight" arrow={{ pointAtCenter: true }} trigger={ ['click'] }>
        <Button icon={ <ThreeDotsVertical/> }/>
      </Dropdown>

      <AppModal
        width={ 400 }
        okText="Видалити"
        okButtonProps={{ danger: true, loading: isDeleteSearchConsoleAccountLoading }}
        cancelButtonProps={{ disabled: isDeleteSearchConsoleAccountLoading }}
        onOk={ handleDeleteSearchConsoleAccount }
        maskClosable={ !isDeleteSearchConsoleAccountLoading }
        title={
          <Flex align="center">
            <Typography.Text type="danger">
              <Flex align="center">
                <ExclamationTriangleFill size={ 24 }/>
              </Flex>
            </Typography.Text>&nbsp;&nbsp;&nbsp;Видалити акаунт?
          </Flex>
        }
        controls={ modalControls }
        closable={ false }
      />
    </>
  );
};
